var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('figure',[_c('img',{staticClass:"image__item",attrs:{"src":_vm.source,"loading":"lazy","alt":_vm.metaTitle,"title":_vm.metaTitle}})])])}
var staticRenderFns = []

export { render, staticRenderFns }